import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
	routes: [{
		path: '*',
		redirect: '/'
	}, {
		path: '/',
		name: 'PageView',
		component: resolve => require(['@/view/PageView'], resolve),
		children: [{
				path: '/',
				redirect: '/home'
			}, {
				path: '/home',
				name: 'home',
				component: resolve => require(['@/view/HomePage'], resolve),
				meta: {
					title: '首页丨家谷商海'
				}
			}, {
				path: '/Culture',
				name: 'Culture',
				component: resolve => require(['@/view/Culture'], resolve),
				meta: {
					title: '宗亲文化丨家谷商海'
				}
			}, {
				path: '/Cloud',
				name: 'Cloud',
				component: resolve => require(['@/view/Cloud'], resolve),
				meta: {
					title: '云平台丨家谷商海'
				}
			}, {
				path: '/dynamic',
				name: 'dynamic',
				component: resolve => require(['@/view/dynamic'], resolve),
				meta: {
					title: '家谷动态丨家谷商海'
				}
			}, {
				path: '/About',
				name: 'About',
				component: resolve => require(['@/view/About'], resolve),
				meta: {
					title: '关于我们丨家谷商海'
				}
			}, {
				path: '/recruit',
				name: 'recruit',
				component: resolve => require(['@/view/recruit'], resolve),
				meta: {
					title: '招贤纳士丨家谷商海'
				}
			}, {
				path: '/ClinicalResearch',
				name: 'ClinicalResearch',
				component: resolve => require(['@/view/ClinicalResearch'], resolve),
				meta: {
					title: '数字化临床研究平台'
				},
				children: [{
						path: '/ClinicalResearch',
						redirect: '/ClinicalResearch/ClinicalOne'
					},
					{
						path: '/ClinicalResearch/ClinicalOne',
						name: 'ClinicalResearch/ClinicalOne',
						component: resolve => require(['@/view/ClinicalOne'], resolve),
						meta: {
							title: '数据隐私及信息安全 | 数字化临床研究平台'
						}
					},
					{
						path: '/ClinicalResearch/ClinicalTwo',
						name: 'ClinicalResearch/ClinicalTwo',
						component: resolve => require(['@/view/ClinicalTwo'], resolve),
						meta: {
							title: '临床研究丨数字化临床研究平台'
						}
					}
				]
			}, {
				path: '/BigLife',
				name: 'BigLife',
				component: resolve => require(['@/view/BigLife'], resolve),
				meta: {
					title: '生命大数据平台'
				},
				children: [{
						path: '/BigLife',
						redirect: '/BigLife/World'
					},
					{
						path: '/BigLife/World',
						name: 'BigLifeWorld',
						component: resolve => require(['@/view/BigLifeWorld'], resolve),
						meta: {
							title: '真实世界研究支持 | 生命大数据平台'
						}
					},
					{
						path: '/BigLife/Medicine',
						name: 'BigLifeMedicine',
						component: resolve => require(['@/view/BigLifeMedicine'], resolve),
						meta: {
							title: '医药市场数据支持丨生命大数据平台'
						}
					},
					{
						path: '/BigLife/Insurance',
						name: 'BigLifeInsurance',
						component: resolve => require(['@/view/BigLifeInsurance'], resolve),
						meta: {
							title: '保险业务支持丨生命大数据平台'
						}
					}
				]
			},{
				path: '/attract',
				name: 'attract',
				component: resolve => require(['@/view/attract'], resolve),
				meta: {
					title: '招商谷丨家谷商海'
				}
			}, {
				path: '/CaseStudy',
				name: 'CaseStudy',
				component: resolve => require(['@/view/CaseStudy'], resolve),
				meta: {
					title: '案例研究'
				}
			}, {
				path: '/WhitePaper',
				name: 'WhitePaper',
				component: resolve => require(['@/view/WhitePaper'], resolve),
				meta: {
					title: '行业白皮书'
				}
			}, {
				path: '/software',
				name: 'software',
				component: resolve => require(['@/view/Software'], resolve),
				meta: {
					title: '软件产品'
				},
				children: [{
						path: '/software',
						redirect: '/software/smartTown'
					},
					{
						path: '/software/smartTown',
						name: 'software',
						component: resolve => require(['@/view/Software_smartTown'], resolve),
						meta: {
							title: '软件产品丨智能小镇管理系统'
						}
					},
					{
						path: '/software/bigData',
						name: 'software',
						component: resolve => require(['@/view/Software_bigData'], resolve),
						meta: {
							title: '软件产品丨大数据管理系统'
						}
					}
				]
			}, {
				path: '/servicedetail',
				name: 'servicedetail',
				component: resolve => require(['@/view/ServiceDetail'], resolve),
				meta: {
					title: '相关服务'
				}
			}, {
				path: '/jobchance',
				name: 'jobchance',
				component: resolve => require(['@/view/JobChance'], resolve),
				meta: {
					title: '加入我们'
				}
			},

		]
	}]
})



// WEBPACK FOOTER //
// ./src/router/index.js